/* eslint-disable */
import { FC, useEffect, useState } from "react";
import XIcon from "src/icons/X";
import { useTranslation } from "react-i18next";
import useAuth from "../../hooks/useAuth";
import automaticTrade from "../../assets/img/automaticTrade.svg"
import {
    Box,
    Button,
    Card,
    CardContent, CircularProgress, Collapse,
    Dialog,
    Grid,
    IconButton,
    Table, TableBody, TableCell,
    TableHead, TableRow,
    Typography
} from "@material-ui/core";
import Scrollbar from "../Scrollbar";
import numeral from 'numeral';
import useIndicators from "../../hooks/useIndicators";
import Cookies from "js-cookie";
import { updateMultipleEstadosPilot } from "../bridges/BridgeTrade";
import { useSnackbar } from "notistack";
import { decodeJWT, getToday } from "../../utils/jwt";
import { useStyles } from '../../pages/dashboard/style';

interface IModalContractProps { }

function Facturas(props: any) {
    const { row, facturaKey, subHeaders } = props;
    const { t } = useTranslation('dashboard');
    const [open, setOpen] = useState(false);
    return (
        <>
            <TableRow key={'prov' + facturaKey} sx={{ backgroundColor: open ? '#E2F1FF' : '#FBFBFB' }}>
                {row.map((cell, idx) => {
                    if (cell.id !== 'facturas') {
                        if (idx === 0) {
                            return (
                                <TableCell component="th" scope="row" key={`cell-${facturaKey}-${idx}`}>
                                    {cell.content}
                                </TableCell>
                            )
                        } else {
                            return (
                                <TableCell component="th" scope="row" align="center" key={`cell-${facturaKey}-${idx}`}>
                                    {cell.content}
                                </TableCell>
                            )
                        }
                    }
                })}
                <TableCell component="th" scope="row" key={'tableCell6' + facturaKey}>
                    <Button
                        size="small"
                        variant="text"
                        onClick={() => setOpen(!open)}
                    >
                        {t(open ? 'modalTrade.tableProviders.hideDetails' : 'modalTrade.tableProviders.showDetails')}
                    </Button>
                </TableCell>
            </TableRow>
            <TableRow key={'facturas' + facturaKey}>
                <TableCell style={{ padding: 0 }} colSpan={8} key={'tableCell8' + facturaKey}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ padding: 0 }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        {subHeaders.map((headCell) => (
                                            <TableCell
                                                style={{
                                                    paddingLeft: 10,
                                                    paddingRight: 0,
                                                    lineHeight: 1,
                                                    backgroundColor: '#DEDEDE',
                                                }}
                                                key={headCell.id + 'i'}
                                                align="center"
                                            >
                                                {headCell.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.map((subRow, sunI) => {
                                        if (subRow.id === 'facturas') {
                                            const factsInfo = subRow.content as Array<any>;
                                            return (
                                                <>
                                                    {factsInfo.map((dataCell) => (
                                                        <TableRow key={'fact' + sunI}>
                                                            {dataCell.map((cell, idx) => (
                                                                <TableCell
                                                                    style={{
                                                                        paddingLeft: 10,
                                                                        paddingRight: 0,
                                                                        lineHeight: 1,
                                                                        backgroundColor: '#FFFFFF',
                                                                    }}
                                                                    key={idx + 'rel'}
                                                                    align="center"
                                                                >
                                                                    {cell.value}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    ))}
                                                </>
                                            )
                                        }
                                    })}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

interface DecodedToken {
    iat?: number;
    claims?: any;
}

const ModalTrade: FC<IModalContractProps> = (props) => {
    const classes = useStyles();
    const dataTrade = Cookies.get('tradeAutomatico');
    const detailsArray = dataTrade ? JSON.parse(decodeURIComponent(dataTrade)) : [];
    const { t } = useTranslation('dashboard');
    const { getTradesDetailArray, tradesDetailsArray, tradeByBusiness, dashboardMaster } = useIndicators();
    const { enqueueSnackbar } = useSnackbar();
    const { user } = useAuth();
    const { ...other } = props;
    const [loading, setLoading] = useState(false);
    const [sending, setSending] = useState(false);
    const [modalOpen, setModalOpen] = useState(true);
    const [dataInvoices, setDataInvoices] = useState([]);
    const [decIds, setDecIds] = useState([]);
    const [valorPagable, setValorPagable] = useState(0);
    const [valorAhorrable, setValorAhorrable] = useState(0);
    const [porcentajePagable, setPorcentajePagable] = useState(0);
    const [manejoEfectivo, setManejoEfectivo] = useState(0);

    //Expiring notif AT
    const [dateAT, setDateAT] = useState<DecodedToken | null>(null);
    const [today, setToday] = useState('');

    useEffect(() => {
        const lifeAT = Cookies.get("lifeAT");
        if (!lifeAT) return;
        try {
            const decoded: DecodedToken | null = decodeJWT(lifeAT);
            if (!decoded) throw new Error("Failed to decode JWT");
            console.log("Decoded Token:", decoded);
            setDateAT(decoded?.claims || null);
            setToday(getToday());
        } catch (err) {
            console.log("Error processing JWT:", err);
            setDateAT(null);
        }
    }, []);

    const handleClose = () => {
        setModalOpen(false);
    };

    const handleProposals = async () => {
        setSending(true);
        try {
            const obj = {
                decissionsIds: decIds,
                estado: 1,
                lang: Cookies.get('language') ? Cookies.get('language') : 'es'
            };
            await updateMultipleEstadosPilot(obj);
            // Cookies.remove('tradeAutomatico')
        } catch (error) {
            console.log(error);
            setSending(false);
        }
        enqueueSnackbar(t('snackBar.proposalSent'), {
            anchorOrigin: {
                horizontal: 'right',
                vertical: 'top',
            },
            variant: 'success',
        });
        setSending(false);
        handleClose();
    }

    const getDetails = async () => {
        const processedRUCs = new Set();
        const tmpDecIds = [];
        const tmpDataInvoice = [];
        let pagableTotal = 0;
        let ahorrableTotal = 0;
        for (const provider of detailsArray) {
            const id = provider.ruc;
            let tmpFacturas = [];
            const trade = tradeByBusiness.find((tradeByBusiness) => tradeByBusiness.identificacion === id);
            if (!processedRUCs.has(id)) {
                if (trade) {
                    //Mrjleo1989 <=> Group by each RUC
                    let maskMoney = `$0,0.00`;
                    const arrInvoicePerSupplierLight = detailsArray.filter((ele) => ele?.ruc === id);
                    const hashedIdSet = new Set(arrInvoicePerSupplierLight.map(ele => ele.hashed_id));
                    const filteredArrInvoicePerSupplierRaw = tradesDetailsArray.filter(ele => hashedIdSet.has(ele.hashedId));
                    filteredArrInvoicePerSupplierRaw.forEach(fac => {
                        const decId = fac['decissionsByDocId'];
                        const tmpFact =
                            [
                                { id: 'fecha', value: fac.fecha_factura.toString().split('T')[0] },
                                { id: 'numero', value: fac.nro_documento },
                                { id: 'total', value: `${numeral(fac.total).format(maskMoney)}` },
                                { id: 'pendiente', value: `${numeral(fac.saldo).format(maskMoney)}` },
                                { id: 'vencimiento', value: `${fac.dias_vencimiento} días` },
                                { id: 'porcentaje', value: `${(fac.descuento_aplicable * 100).toFixed(2)}%` },
                                { id: 'pagable', value: `${numeral(fac.pagable_1).format(maskMoney)}` },
                                { id: 'ahorrable', value: `${numeral(fac.ahorrable_1).format(maskMoney)}` },
                                { id: 'pagado', value: `${numeral(fac.retenciones).format(maskMoney)}` },
                                { id: 'nc', value: `${numeral(fac.nc).format(maskMoney)}` },
                                { id: 'tasa', value: `${(fac.tasa_efectiva * 100).toFixed(2)} %` },
                            ];
                        tmpDecIds.push(decId);
                        tmpFacturas.push(tmpFact);
                    })

                    let totalTotal = filteredArrInvoicePerSupplierRaw.reduce((sum, dec) => sum + Number(dec.total), 0);
                    let totalSaldo = filteredArrInvoicePerSupplierRaw.reduce((sum, dec) => sum + Number(dec.saldo), 0);
                    let totalPagable1 = filteredArrInvoicePerSupplierRaw.reduce((sum, dec) => sum + Number(dec.pagable_1), 0);
                    let totalAhorrable1 = filteredArrInvoicePerSupplierRaw.reduce((sum, dec) => sum + Number(dec.ahorrable_1), 0);
                    let totalTasaEfectiva = filteredArrInvoicePerSupplierRaw.reduce((sum, dec) => sum + Number(dec.tasa_efectiva), 0);
                    const totalInvoicePerSupplier = arrInvoicePerSupplierLight.length;

                    const tempData =
                        [
                            { id: 'name', content: trade.name },
                            { id: 'facturado', content: `${numeral(totalTotal).format(maskMoney)}` },
                            { id: 'pendiente', content: `${numeral(totalSaldo).format(maskMoney)}` },
                            { id: 'pagable', content: `${numeral(totalPagable1).format(maskMoney)}` },
                            { id: 'ahorrable', content: `${numeral(totalAhorrable1).format(maskMoney)}` },
                            { id: 'tasa', content: `${((totalTasaEfectiva / totalInvoicePerSupplier) * 100).toFixed(2)} %` },
                            { id: 'numero', content: totalInvoicePerSupplier },
                            { id: 'facturas', content: tmpFacturas }
                        ];
                    tmpDataInvoice.push(tempData);
                    pagableTotal += totalPagable1;
                    ahorrableTotal += totalAhorrable1;
                }
                processedRUCs.add(id);
            }
        }
        const tmpEfectivoMax = dashboardMaster?.businessManejoEfectivo.efectivoMaximoDisponible !== 0 ? dashboardMaster?.businessManejoEfectivo.efectivoMaximoDisponible : 2550650;
        const tmpPagablePer = ((pagableTotal * 100) / tmpEfectivoMax);
        setDecIds(tmpDecIds);
        setManejoEfectivo(tmpEfectivoMax);
        setDataInvoices(tmpDataInvoice);
        setValorPagable(pagableTotal);
        setValorAhorrable(ahorrableTotal);
        setPorcentajePagable(tmpPagablePer);
    }

    useEffect(() => {
        const getInvoices = async () => {
            const rucs = [];
            detailsArray.forEach(prov => {
                const tmpRuc = prov.ruc;
                rucs.push(tmpRuc);
            })
            await getTradesDetailArray(rucs);
            setLoading(true);
        }

        getInvoices();
    }, []);

    useEffect(() => {
        if (tradeByBusiness.length !== 0 && dashboardMaster) {
            getDetails().then(() => {
                setLoading(false);
            });
        }
    }, [tradeByBusiness, dashboardMaster]);

    const headers = [
        { id: 'name', label: `${t('modalTrade.tableProviders.headers.providers')}` },
        { id: 'facturado', label: `${t('modalTrade.tableProviders.headers.totalValue')}` },
        { id: 'pendientePagar', label: `${t('modalTrade.tableProviders.headers.pendingValue')}` },
        { id: 'pagable', label: `${t('modalTrade.tableProviders.headers.payValue')}` },
        { id: 'ahorrable', label: `${t('modalTrade.tableProviders.headers.saveValue')}` },
        { id: 'tasa', label: `${t('modalTrade.tableProviders.headers.annualRate')}` },
        { id: 'numeroFactura', label: `${t('modalTrade.tableProviders.headers.number')}` },
        { id: 'detalles', label: `${t('modalTrade.tableProviders.headers.details')}` }
    ];

    const subHeaders = [
        { id: 'fecha', label: `${t('modalTrade.tableInvoice.headers.invoiceDate')}` },
        { id: 'numero', label: `${t('modalTrade.tableInvoice.headers.invoiceNumber')}` },
        { id: 'total', label: `${t('modalTrade.tableInvoice.headers.totalValue')}` },
        { id: 'pendiente', label: `${t('modalTrade.tableInvoice.headers.pendingValue')}` },
        { id: 'vencimiento', label: `${t('modalTrade.tableInvoice.headers.expiringDays')}` },
        { id: 'porcentaje', label: `${t('modalTrade.tableInvoice.headers.discountPercentage')}` },
        { id: 'pagable', label: `${t('modalTrade.tableInvoice.headers.paymentValue')}` },
        { id: 'ahorrable', label: `${t('modalTrade.tableInvoice.headers.saveValue')}` },
        { id: 'pagado', label: `${t('modalTrade.tableInvoice.headers.paidValue')}` },
        { id: 'nc', label: `${t('modalTrade.tableInvoice.headers.savingsGenerated')}` },
        { id: 'tasa', label: `${t('modalTrade.tableInvoice.headers.annualRate')}` }
    ];

    return (
        <Dialog maxWidth="lg" open={modalOpen} onClose={handleClose}>
            <Box display="flex" justifyContent="flex-start">
                <IconButton onClick={handleClose}>
                    <XIcon fontSize="small" />
                </IconButton>
            </Box>
            <Box sx={{ margin: 4 }}>
                <Grid container>
                    <Grid item xs={12} display="flex" justifyContent="left">
                        <Typography
                            color="#024787"
                            fontWeight={700}
                            fontSize="22px"
                        >
                            ¡{t('modalTrade.welcomeClient')}, {user.firstName}!
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                    >
                        <Box
                            alt="Trade Release"
                            component="img"
                            src={automaticTrade}
                            sx={{ width: '15%' }}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                        pt={4}
                    >
                        <Typography
                            color="#EBB100"
                            fontWeight={900}
                            fontSize="28px"
                        >
                            {t('modalTrade.trade')}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                    >
                        <Typography
                            color="#001930BF"
                            fontWeight={700}
                            fontSize="22px"
                        >
                            {t('modalTrade.learnHow')}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="flex-start"
                        py={2}
                    >
                        <Typography
                            color="#5d6b83"
                            fontWeight={400}
                            fontSize="16px"
                            pl={2}
                        >
                            {t('modalTrade.description')}
                        </Typography>
                    </Grid>
                    {today === dateAT ? (
                        loading ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: '100%',
                                    alignItems: 'center',
                                    height: '12vh'
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        ) : (
                            <>
                                <Grid
                                    item
                                    xs={12}
                                    display="flex"
                                    justifyContent="space-around"
                                >
                                    <Box
                                        bgcolor="#e0e0e0"
                                        borderRadius="8px"
                                        px={2}
                                        py={1}
                                    >
                                        <Typography color="#034787">
                                            <span style={{ fontWeight: 600, fontSize: "14px" }}>
                                                {t('modalTrade.totalValue')}:
                                            </span>
                                            <span style={{ fontWeight: 900, fontSize: "18px", paddingLeft: '5px' }}>
                                                {numeral(manejoEfectivo).format(`$0,0.00`)}
                                            </span>
                                        </Typography>

                                    </Box>
                                    <Box
                                        bgcolor="#012C54"
                                        borderRadius="8px"
                                        px={2}
                                        py={1}
                                    >
                                        <Typography color="#FFFFFF">
                                            <span style={{ fontWeight: 600, fontSize: "14px" }}>
                                                {t('modalTrade.saveValue')}
                                            </span>
                                            <span style={{ fontWeight: 900, fontSize: "18px", paddingLeft: '5px' }}>
                                                {numeral(valorAhorrable).format(`$0,0.00`)}
                                            </span>
                                        </Typography>
                                    </Box>
                                    <Box
                                        bgcolor="#e0e0e0"
                                        borderRadius="8px"
                                        px={2}
                                        py={1}
                                    >
                                        <Typography color="#034787">
                                            <span style={{ fontWeight: 600, fontSize: "14px" }}>
                                                {t('modalTrade.payValue')}
                                            </span>
                                            <span style={{ fontWeight: 900, fontSize: "18px", paddingLeft: '5px' }}>
                                                {numeral(valorPagable).format(`$0,0.00`)}
                                            </span>
                                            <span style={{ fontWeight: 600, fontSize: "18px", paddingLeft: '5px' }}>
                                                ({porcentajePagable.toFixed(2)}%)
                                            </span>
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} pt={3}>
                                    <Card {...other}>
                                        <CardContent>
                                            <Scrollbar>
                                                <Box sx={{ minHeight: 250, maxHeight: 650 }}>
                                                    <Table stickyHeader size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                {headers.map((headCell) => (
                                                                    <TableCell
                                                                        style={{
                                                                            paddingLeft: 10,
                                                                            paddingRight: 0,
                                                                            lineHeight: 1,
                                                                            backgroundColor: '#FFFFFF',
                                                                        }}
                                                                        key={headCell.id + 'i'}
                                                                        align="center"
                                                                    >
                                                                        {headCell.label}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dataInvoices.map((row, i) => (
                                                                <Facturas
                                                                    key={i + 'fac'}
                                                                    facturaKey={i + 'fac'}
                                                                    row={row}
                                                                    subHeaders={subHeaders}>
                                                                </Facturas>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Box>
                                            </Scrollbar>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    mt={2}
                                    display="flex"
                                    justifyContent="center"
                                >
                                    {sending ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <CircularProgress />
                                        </Box>
                                    ) : (
                                        <Button
                                            style={{ backgroundColor: "#024787", padding: "10px 15px", color: "white", textTransform: "uppercase" }}
                                            onClick={handleProposals}
                                        >
                                            {t('modalTrade.sendTrade')}
                                        </Button>
                                    )}
                                </Grid>
                            </>
                        )
                    ) : (
                        <div className={classes.divCentered}>
                            <Typography className={classes.titleModal} color={'red'}>
                                ¡Las ofertas han caducado, mantente pendiente de una próxima notificación!
                            </Typography>
                        </div>
                    )}

                </Grid>
            </Box>
        </Dialog>
    )
}

ModalTrade.propTypes = {};

export default ModalTrade;